import { createFileRoute } from '@tanstack/react-router';

import { EvidenceDetailPage } from '@/features/evidence-logs';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/evidence/$evidenceId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.evidenceDetail'),
  }),
  component: EvidenceDetailRoute,
});

function EvidenceDetailRoute() {
  const { evidenceId } = Route.useParams();

  return <EvidenceDetailPage evidenceId={evidenceId} />;
}
